import PromotingImage from "src/components/PromotingImage";
import parseV0TemplateUrl from "src/helpers/parseV0TemplateUrl";
import { PhotoDisplayContentProps } from "../types";

const PhotoDisplayImageContent = ({
	photo,
	photoWidth,
	photoHeight,
	onLoad,
	onDetailedLoad,
	isActive,
}: PhotoDisplayContentProps) => {
	const imageUrl = parseV0TemplateUrl({
		readUrl: photo.readUrl,
		strategy: "inside",
		size: "lg",
	});
	const upgradedImageUrl = isActive
		? parseV0TemplateUrl({
				readUrl: photo.readUrl,
				strategy: "inside",
				size: "xxl",
			})
		: undefined;

	if (!imageUrl) return null;
	return (
		<PromotingImage
			// Parallel load since due to lazy cold start on optimization, it's possible that stable is ready sooner
			parallelLoading
			onBaseImageLoad={() => {
				onLoad?.({
					success: true,
				});
			}}
			onUpgradedImageLoad={() => {
				onDetailedLoad?.({
					success: true,
				});
			}}
			onError={() => {
				onLoad?.({
					success: false,
				});
			}}
			alt="Photo"
			src={imageUrl}
			upgradedSrc={upgradedImageUrl}
			dim={{ width: photoWidth, height: photoHeight }}
			style={{ width: photoWidth, height: photoHeight }}
			webLoadingBehavior="eager"
			pointerEvents="none"
			contentFit="contain"
			blurHash={photo.blurHash ?? undefined}
		/>
	);
};
export default PhotoDisplayImageContent;
